/* Scuffers-style discount chips on the homepage product grid.
   Tiers come from the WHOLE all-products collection (fetched client-side),
   not just the cards rendered on the page. Clicking a tier replaces the grid
   with every matching product from the collection; "All Discounts" restores
   the original grid. */
(() => {
  const COLLECTION = '/collections/all-products/products.json?limit=250';

  const money = (v) => {
    const n = parseFloat(v);
    if (isNaN(n)) return '';
    return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
  };

  const productPct = (p) => {
    const v = p.variants.find((x) => x.compare_at_price && parseFloat(x.compare_at_price) > parseFloat(x.price));
    if (!v) return 0;
    return Math.round((1 - parseFloat(v.price) / parseFloat(v.compare_at_price)) * 100);
  };

  const productColor = (p) => {
    const i = (p.options || []).findIndex((o) => /colou?r/i.test(o.name || o));
    if (i === -1) return '';
    const v = p.variants[0];
    return v ? v['option' + (i + 1)] || '' : '';
  };

  const cardHTML = (p) => {
    const pct = productPct(p);
    const v = p.variants[0];
    const img = p.images && p.images[0] ? p.images[0].src + (p.images[0].src.includes('?') ? '&' : '?') + 'width=800' : '';
    const compare = v && v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)
      ? '<s class="lg-x-old">' + money(v.compare_at_price) + '</s>' : '';
    return (
      '<a class="lg-x-card" href="/products/' + p.handle + '">' +
        '<div class="lg-x-media">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          (pct ? '<span class="product-badges__badge lg-x-badge"><span class="lg-x-badge__text">-' + pct + '%</span></span>' : '') +
        '</div>' +
        '<div class="lg-x-meta">' +
          '<div class="lg-x-titlecol">' +
            '<span class="lg-x-title">' + p.title + '</span>' +
            '<span class="lg-x-color">' + productColor(p) + '</span>' +
          '</div>' +
          '<div class="lg-x-price"><span class="lg-x-new">' + money(v ? v.price : '') + '</span>' + compare + '</div>' +
        '</div>' +
      '</a>'
    );
  };

  const init = async () => {
    const main = document.querySelector('main[data-template="index"]');
    if (!main) return;
    const section = [...main.querySelectorAll('.section-resource-list')].find(
      (s) => s.querySelector('.resource-list__item')
    );
    if (!section || section.dataset.lgChips) return;
    const header = section.querySelector('.section-resource-list__header');
    if (!header) return;
    section.dataset.lgChips = '1';

    let products = [];
    try {
      const res = await fetch(COLLECTION);
      products = (await res.json()).products || [];
    } catch (e) {
      return; // no data, no chips
    }

    const tiers = [40, 45, 55, 60, 65, 70];
    if (!tiers.length) return;

    const originals = [...section.querySelectorAll('.resource-list__item')];
    const grid = originals[0] ? originals[0].parentElement : null;
    if (!grid) return;

    const row = document.createElement('div');
    row.className = 'lg-chip-row';

    const clearInjected = () => grid.querySelectorAll('.lg-x-item').forEach((n) => n.remove());

    const select = (btn, n) => {
      row.querySelectorAll('.lg-chip').forEach((c) => c.classList.remove('lg-chip--active'));
      btn.classList.add('lg-chip--active');
      clearInjected();
      if (n == null) {
        originals.forEach((it) => (it.style.display = ''));
        return;
      }
      originals.forEach((it) => (it.style.display = 'none'));
      const frag = document.createDocumentFragment();
      products.filter((p) => productPct(p) === n).forEach((p) => {
        const el = document.createElement('div');
        el.className = 'resource-list__item lg-x-item';
        el.innerHTML = cardHTML(p);
        frag.appendChild(el);
      });
      grid.appendChild(frag);
    };

    const defs = [['All Discounts', null], ...tiers.map((p) => ['-' + p + '%', p])];
    defs.forEach(([label, n], i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lg-chip' + (i === 0 ? ' lg-chip--active' : '');
      btn.textContent = label;
      btn.addEventListener('click', () => select(btn, n));
      row.appendChild(btn);
    });

    const inner = header.querySelector('.group-block-content, .layout-panel-flex') || header;
    inner.appendChild(row);
  };

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
